import {config as numberColumnConfig} from '../../common/NumberColumn';

export const prop = 'pTOD';

export const config = (labels) =>
	numberColumnConfig({
		id: 'gaOverdue',
		label: labels.overdueLabel,
		prop,
		width: 'minmax(var(--px-130), 1fr)'
	});
